import React, { useState, useEffect } from 'react'
import { Close } from '@material-ui/icons'

import {
  Card,
  CardContent,
  IconButton,
  Grid,
  Button,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
} from '@material-ui/core'
import { updateAssignedShopIdList } from '../../actions/shop'
import { cannabisTypeOptionsList } from '../../utils/common'
import { openErrorMessage } from '../../actions/message'
import { areArraysEqual } from '../../utils/array'
import { EditableSwitch } from '../common/EditableComponents'
import MultiSelectCheckbox from '../CompanyInfo/MultiSelectCheckbox'

export default function LabelDialog(props) {
  const {
    label,
    onClose,
    open,
    shops,
    dispatch,
    onUpdated,
    companyId,
    consumerTypeOptions,
    labels,
  } = props

  const [assignedTo, setAssignedTo] = useState([])
  const [active, setActive] = useState(false)
  const [filteredShops, setFilteredShops] = useState([])
  const [consumerTypes, setConsumerTypes] = useState([])
  const [cannabisTypes, setCannabisTypes] = useState([])

  useEffect(() => {
    if (label) {
      let filteredShops = []
      if (shops && shops.length > 0) {
        if (label.restricted) {
          if (
            label.assignedCompanies &&
            label.assignedCompanies.length > 0 &&
            label.assignedCompanies.includes(companyId)
          ) {
            //restricted with company allows all shops
            filteredShops = shops
          } else if (label.allowedStates && label.allowedStates.length > 0) {
            filteredShops = shops.filter((shop) => {
              const state = shop.address && shop.address.state
              return state && label.allowedStates.includes(state)
            })
          }
        } else {
          filteredShops = shops
        }

        const shopOptions = [{ id: 'DEFAULT', name: 'ALL' }, ...filteredShops]
        setFilteredShops(shopOptions)
      }

      const assignedShops = label.assignedShops[companyId] || []
      if (assignedShops != assignedTo) setAssignedTo(assignedShops || [])
      if (assignedShops.length === 0 || assignedShops.length === filteredShops.length)
        setAssignedTo(['DEFAULT'])

      const { consumerTypes = [], cannabisTypes = [], deleted } = label.rule || {}
      consumerTypes.length > 0 ? setConsumerTypes(consumerTypes) : setConsumerTypes(['DEFAULT'])
      cannabisTypes.length > 0 ? setCannabisTypes(cannabisTypes) : setCannabisTypes(['DEFAULT'])

      if (deleted == undefined || deleted == null) {
        assignedShops.length === 0 ? setActive(false) : setActive(true)
      } else {
        setActive(!deleted)
      }
    }
  }, [props.label])

  const handleAssignedToChange = (event) => {
    setAssignedTo(() => cleanValues(event))
  }

  const cleanValues = (event) => {
    const selectedValues = event.target.value
    if (selectedValues.includes('DEFAULT') && selectedValues[0] !== 'DEFAULT') return ['DEFAULT']
    const filteredValues = selectedValues.filter((value) => value !== 'DEFAULT')
    return filteredValues.length === 0 ? ['DEFAULT'] : filteredValues
  }

  const selectedAllShops = () => {
    return filteredShops.filter((shop) => shop.id !== 'DEFAULT').map((shop) => shop.id)
  }

  const deleteAssignedTo = (value) => {
    if (value === 'DEFAULT') return
    assignedTo.length === 1
      ? setAssignedTo(['DEFAULT'])
      : setAssignedTo((assignedTo) => assignedTo.filter((el) => el !== value))
  }

  const getShopName = (id) => {
    const shopOptions = [{ id: 'DEFAULT', name: 'ALL' }, ...shops]
    for (let el of shopOptions) if (id == el.id) return el.name
    return null
  }

  const updateAssignedShopsList = async () => {
    const newLabelTemplate = {
      assignedShopIds: assignedTo.includes('DEFAULT') ? selectedAllShops() : assignedTo,
      assignedConsumerTypes: consumerTypes.includes('DEFAULT') ? [] : consumerTypes,
      assignedCannabisTypes: cannabisTypes.includes('DEFAULT') ? [] : cannabisTypes,
      labelTemplateRuleId: (label && label.rule && label.rule.id) || '',
      deleted: !active,
    }

    if (isDuplicateLabelConfig(newLabelTemplate)) {
      dispatch(openErrorMessage('A label with this configuration already exists'))
      return
    }

    await dispatch(updateAssignedShopIdList(label.id, newLabelTemplate))
    onUpdated()
    closeDialog()
  }

  const isDuplicateLabelConfig = (newLabelTemplate = {}) => {
    const { assignedShopIds, assignedConsumerTypes, assignedCannabisTypes, labelTemplateRuleId } =
      newLabelTemplate
    return labels.some((label) => {
      const rule = label.rule || {}
      if (rule.id === labelTemplateRuleId) return false
      if (
        assignedShopIds.length === filteredShops.length - 1 &&
        assignedConsumerTypes.length === 0 &&
        assignedCannabisTypes.length === 0
      )
        return false
      return (
        areArraysEqual(assignedShopIds, rule.shopIds) &&
        areArraysEqual(assignedConsumerTypes, rule.consumerTypes) &&
        areArraysEqual(assignedCannabisTypes, rule.cannabisTypes)
      )
    })
  }

  const labelDialogClassName = () => {
    if (!open) return 'label-dialog'
    return 'label-dialog active'
  }

  const closeDialog = () => {
    setAssignedTo([])
    setConsumerTypes([])
    setCannabisTypes([])
    setActive(false)
    onClose()
  }

  const isLabelRestrictedWithStates = () => {
    return label && label.restricted && label.allowedStates && label.allowedStates.length > 0
  }

  const getAllowedStates = () => {
    if (isLabelRestrictedWithStates()) {
      return label.allowedStates.join(', ')
    }
    return ''
  }

  const cannabisTypeOptions = cannabisTypeOptionsList.map((option) =>
    option.value === 'DEFAULT' ? { ...option, label: 'ALL' } : option,
  )

  return (
    <Card className={labelDialogClassName()}>
      {open ? <div className="overlay" /> : null}
      <IconButton onClick={closeDialog} style={{ marginTop: '20px', marginLeft: '10px' }}>
        <Close />
      </IconButton>
      <CardContent style={{ paddingTop: '0' }}>
        <h1 className="title">{label && label.labelName}</h1>
        <center>
          <img
            src={label && label.templateThumbnail && label.templateThumbnail.largeURL}
            className="label-img"
          />
        </center>
        <form action="">
          <div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Label Name</p>
              <span>{label && label.labelName}</span>
            </div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Label Description</p>
              <span>{label && label.description}</span>
            </div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Label Type</p>
              <span>{label && label.labelType}</span>
            </div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Size</p>
              <span>{label && `${label.width}" x ${label.height}"`}</span>
            </div>
            {isLabelRestrictedWithStates() && (
              <div className="dialog-section">
                <p className="font-weight-bold subtitle">Allowed States</p>
                <span>{getAllowedStates()}</span>
              </div>
            )}
            <div className="dialog-section">
              <Grid container xs={12}>
                <Grid item xs={6}>
                  <p className="font-weight-bold subtitle">Active</p>
                </Grid>
                <Grid item xs={6}>
                  <EditableSwitch
                    valueToRender={active ? 'Disabled' : 'Enabled'}
                    editMode={true}
                    checked={active}
                    onChange={(e) => setActive(e.target.checked)}
                  />
                </Grid>
              </Grid>
            </div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Assigned To</p>
              <FormControl fullWidth>
                <Select
                  multiple
                  value={assignedTo}
                  onChange={handleAssignedToChange}
                  // input={<Input rowsMax="5" />}
                  renderValue={(selected) =>
                    assignedTo
                      .filter((value) => getShopName(value) != null)
                      .map((value) => (
                        <Chip
                          key={value}
                          label={getShopName(value)}
                          color="primary"
                          style={{ color: 'white' }}
                          deleteIcon={<Close style={{ color: 'white' }} />}
                          onDelete={() => deleteAssignedTo(value)}
                          hidden
                        />
                      ))
                  }
                >
                  {filteredShops.map((shop) => (
                    <MenuItem key={shop.id} value={shop.id}>
                      <Checkbox
                        color="primary"
                        readOnly
                        checked={assignedTo && assignedTo.indexOf(shop.id) > -1}
                      />
                      <ListItemText primary={shop.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="dialog-section">
              <MultiSelectCheckbox
                label="Consumer Type"
                options={consumerTypeOptions}
                selectedValues={consumerTypes}
                onChange={(value) => setConsumerTypes(cleanValues(value))}
                onDelete={(value) => {
                  if (value === 'DEFAULT') return
                  consumerTypes.length === 1
                    ? setConsumerTypes(['DEFAULT'])
                    : setConsumerTypes((values) => values.filter((item) => item !== value))
                }}
              />
            </div>
            <div className="dialog-section">
              <MultiSelectCheckbox
                label="Cannabis Type"
                options={cannabisTypeOptions}
                selectedValues={cannabisTypes}
                onChange={(value) => setCannabisTypes(cleanValues(value))}
                onDelete={(value) => {
                  if (value === 'DEFAULT') return
                  cannabisTypes.length === 1
                    ? setCannabisTypes(['DEFAULT'])
                    : setCannabisTypes((values) => values.filter((item) => item !== value))
                }}
              />
            </div>
          </div>
          <div className="dialog-section">
            <Grid container justify="space-between">
              <Grid item>
                <Button
                  style={{ color: '#F25E3D' }}
                  className="dialog-action"
                  onClick={closeDialog}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  className="dialog-action"
                  onClick={updateAssignedShopsList}
                >
                  Update / Save
                </Button>
              </Grid>
            </Grid>
          </div>
        </form>
      </CardContent>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/components/Modal/LabelDialog.js